$(document).ready(function(){

   var swiper_slider_navigation = new Swiper(".js-gallery-preview-slider .js-gallery-preview-slider-navigation", {
        spaceBetween:        10,
        slidesPerView:       4,
        freeMode:            true,
        watchSlidesProgress: true,

        // Responsive settings
        breakpoints: {
            0: {
                slidesPerView: 2.5,
            },
            768: {
                slidesPerView: 4,
            },
        },
    });

    var swiper_slider_image = new Swiper( ".js-gallery-preview-slider .js-gallery-preview-slider-image", {
        spaceBetween: 10,
        navigation:   {
            nextEl: ".js-gallery-preview-slider-next",
            prevEl: ".js-gallery-preview-slider-prev",
        },
        thumbs: {
            swiper: swiper_slider_navigation,
        },
    } );
});
